import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import {
  SearchContext,
  SearchContextInterface
} from '../../../../search-new/context/SearchContext';
import { useContext } from 'react';
import { SearchFiltersActionTypes } from '../../../../../reducers/search-filters/actions';
import { SearchFiltersTypes } from '../../../../../reducers/search-filters/reducer';
import { useRouter } from 'next/router';
import { updateQuery } from '../../../../../helpers/common';

const ResetFilters = ({ hasAvailability }: { hasAvailability?: boolean }) => {
  const { t } = useTranslation('common');
  const { searchFiltersDispatch } = useContext(
    SearchContext
  ) as SearchContextInterface;
  const router = useRouter();
  const handleResetFilters = () => {
    searchFiltersDispatch({
      type: SearchFiltersActionTypes.RESET
    });

    searchFiltersDispatch({
      type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE,
      payload: {
        name: SearchFiltersTypes.CATEGORY,
        value: 'property'
      }
    });

    const filterKeys = Object.values(SearchFiltersTypes);
    const keysToRemove = Object.keys(router.query).filter(key =>
      filterKeys.includes(key as SearchFiltersTypes)
    );
    updateQuery(router, undefined, keysToRemove);
  };

  return (
    <Container>
      <div className="content">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="70"
          height="70"
          viewBox="0 0 70 70"
          fill="none"
        >
          <path
            d="M30.9173 12.1029C30.9173 12.657 30.4506 13.1237 29.8965 13.1237H26.6006C20.3006 13.1237 15.1673 18.257 15.1673 24.557V51.4779C15.1673 52.032 14.7007 52.4987 14.1465 52.4987H12.1048C8.63398 52.4987 5.83398 49.6987 5.83398 46.2279V12.1029C5.83398 8.63203 8.63398 5.83203 12.1048 5.83203H24.6465C28.1173 5.83203 30.9173 8.63203 30.9173 12.1029Z"
            fill="#DCE2E7"
          />
          <path
            d="M41.6143 17.5C41.487 18.2587 41.4199 19.0382 41.4199 19.833C41.42 25.8958 45.2743 31.0575 50.666 33.0039V57.1377C50.6659 61.0167 47.5158 64.1669 43.6367 64.167H38.6494C37.8327 64.167 37.1904 63.5247 37.1904 62.708V55.417C37.1904 54.2212 36.1988 53.2295 35.0029 53.2295C33.8072 53.2297 32.8154 54.2213 32.8154 55.417V62.708C32.8154 63.5247 32.1741 64.167 31.3574 64.167H26.6035C22.6952 64.167 19.545 61.0167 19.5449 57.1084V24.5586C19.5449 20.6503 22.6952 17.5 26.6035 17.5H41.6143ZM29.1699 38.6455C27.9742 38.6455 26.9826 39.6373 26.9824 40.833C26.9824 42.0288 27.9741 43.0205 29.1699 43.0205H40.8369C42.0326 43.0203 43.0244 42.0287 43.0244 40.833C43.0242 39.6374 42.0325 38.6457 40.8369 38.6455H29.1699ZM29.1699 29.8955C27.9742 29.8955 26.9826 30.8873 26.9824 32.083C26.9824 33.2788 27.9741 34.2705 29.1699 34.2705H40.8369C42.0326 34.2703 43.0244 33.2787 43.0244 32.083C43.0242 30.8874 42.0325 29.8957 40.8369 29.8955H29.1699Z"
            fill="#DCE2E7"
          />
          <path
            d="M63.0504 12.658C63.0285 12.658 63.0285 12.6361 63.0285 12.6361V12.6143C61.1035 10.6018 58.4129 9.33301 55.416 9.33301C49.6191 9.33301 44.916 14.0361 44.916 19.833C44.916 22.5236 45.9441 24.9736 47.6066 26.833C49.5316 28.9768 52.3098 30.333 55.416 30.333C61.2129 30.333 65.916 25.6299 65.916 19.833C65.916 17.0549 64.8223 14.5393 63.0504 12.658ZM59.3754 23.9236C59.0691 24.2299 58.6316 24.4049 58.216 24.4049C57.8004 24.4049 57.3848 24.2299 57.0566 23.9236L55.4379 22.3049L53.7754 23.9893C53.4473 24.2955 53.0316 24.4705 52.616 24.4705C52.3973 24.4705 52.2004 24.4268 52.0035 24.3393C51.8066 24.2736 51.6098 24.1424 51.4566 23.9893C50.8004 23.333 50.8004 22.3049 51.4566 21.6705L53.1191 19.9861L51.5223 18.3674C50.866 17.733 50.866 16.683 51.5223 16.0486C52.1566 15.4143 53.1848 15.4143 53.841 16.0486L55.4379 17.6674L56.991 16.1143C57.6473 15.4799 58.6754 15.4799 59.3098 16.1143C59.6816 16.4861 59.8348 16.9674 59.7691 17.4486C59.7473 17.8205 59.5941 18.1705 59.3098 18.433L57.7566 19.9861L59.3754 21.6049C60.0316 22.2393 60.0316 23.2674 59.3754 23.9236Z"
            fill="#4E565E"
          />
        </svg>
        {hasAvailability ? (
          <>
            <div className="typo">
              <span>{t('no_results_found')}</span>
              <p>{t('no_results_found_description')}</p>
            </div>
            <button className="reset-filters" onClick={handleResetFilters}>
              {t('reset_filters')}
            </button>
          </>
        ) : (
          <div className="typo">
            <span>{t('no_units_available')}</span>
          </div>
        )}
      </div>
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    max-width: 286px;
    width: 100%;

    .typo {
      margin: 24px auto 16px;
      display: flex;
      flex-direction: column;
      gap: 4px;
      span {
        color: #2c3138;
        font-family: materialSemiBold;
        font-size: 18px;
        line-height: normal;
        text-transform: capitalize;
      }
      p {
        color: #5b6573;
        font-family: materialRegular;
        font-size: 16px;
        line-height: normal;
        text-transform: capitalize;
      }
    }

    button {
      border: none;
      background: none;
      outline: none;
      color: #015c9a;
      font-family: materialMedium;
      font-size: 16px;
      line-height: normal;
      text-transform: capitalize;
    }
  }
`;
export default ResetFilters;
